import { API_LIMIT_DATA } from '../utils/constants';
import * as actions from './constants';

const initialState = {
  data: null,
  limit: API_LIMIT_DATA,
  offset: 1,
  hasMore: false
};

// eslint-disable-next-line default-param-last
export default function notificationReducer(state = initialState, action) {
  switch (action.type) {
    case actions.ADD_NOTIFICATIONS: {
      const newNotifications = action.payload.data;
      const existingNoti = state.data ? [...state.data] : newNotifications;
      if (state.data) {
        newNotifications.forEach((noti) => {
          const findIndex = state.data.findIndex((cd) => (cd?.id ?? cd?._id) === noti.id);
          if (findIndex === -1) {
            existingNoti.push(noti);
          }
        });
      }
      return {
        ...state,
        data: [...existingNoti],
        offset: action.payload.offset,
        hasMore: action.payload.data.length === API_LIMIT_DATA
      };
    }
    case actions.UPDATE_NOTIFICATION: {
      const updatedNoti = action.payload.data;
      const findIndex = state.data.findIndex((noti) => (noti?.id ?? noti?._id) === updatedNoti.id);
      if (findIndex > -1) {
        state.data[findIndex] = updatedNoti;

        return {
          ...state,
          data: [...state.data]
        };
      }
      return state;
    }

    case actions.MARK_ALL_READ: {
      return {
        ...state,
        data: state.data.map((item) => ({ ...item, isRead: true }))
      };
    }

    case actions.RESET_STATE:
      return {
        data: null,
        offset: 1,
        hasMore: false
      };

    default:
      return state;
  }
}
